module.exports = __webpack_public_path__ + "img/1.f018a802.jpeg";